module.exports = __webpack_public_path__ + "media/images/mailer/logolepoulpe-667eff15283cbcd9184c094ff9b6e286.jpg";